import React from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { useTheme } from '@mui/material/styles'
import { User, Shield } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
    getProfileMobileTabStyles,
    getProfileSidebarItemButtonStyles,
    getProfileTabIndicatorStyle,
    profileLayoutStyles,
} from './ProfileLayout.styles'

const ProfileLayout: React.FC = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const theme = useTheme()

    const menuItems = [
        { label: t('nav.profile'), href: '/app/profile', icon: User, exact: true },
        { label: t('nav.privacySettings'), href: '/app/profile/privacy-settings', icon: Shield, exact: false },
    ]

    const activeIndex = menuItems.findIndex(item =>
        item.exact
            ? location.pathname === item.href
            : location.pathname.startsWith(item.href)
    )

    return (
        <Box sx={profileLayoutStyles.layoutContainer}>

            {/* ─── Levý sidebar — desktop (sm+) ─────────────────────── */}
            <Box sx={profileLayoutStyles.sidebarContainer}>
                <List
                    disablePadding
                    sx={profileLayoutStyles.sidebarList}
                >
                    {menuItems.map((item) => {
                        const Icon = item.icon
                        const active = item.exact
                            ? location.pathname === item.href
                            : location.pathname.startsWith(item.href)

                        return (
                            <ListItemButton
                                key={item.href}
                                component={Link}
                                to={item.href}
                                selected={active}
                                sx={getProfileSidebarItemButtonStyles()}
                            >
                                <ListItemIcon sx={profileLayoutStyles.sidebarItemIcon}>
                                    <Icon size={20} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.label}
                                    primaryTypographyProps={{ variant: 'body2', fontWeight: active ? 600 : 400 }}
                                />
                            </ListItemButton>
                        )
                    })}
                </List>
            </Box>

            {/* ─── Obsah ────────────────────────────────────────────── */}
            <Box sx={profileLayoutStyles.contentContainer}>

                {/* Horizontální tabs — mobile (xs) */}
                <Box sx={profileLayoutStyles.mobileTabsContainer}>
                    <Tabs
                        value={activeIndex >= 0 ? activeIndex : 0}
                        variant="scrollable"
                        scrollButtons="auto"
                        TabIndicatorProps={{ style: getProfileTabIndicatorStyle(theme) }}
                        sx={profileLayoutStyles.mobileTabs}
                    >
                        {menuItems.map((item) => {
                            const Icon = item.icon
                            return (
                                <Tab
                                    key={item.href}
                                    component={Link}
                                    to={item.href}
                                    label={
                                        <Box sx={profileLayoutStyles.mobileTabLabel}>
                                            <Icon size={16} />
                                            {item.label}
                                        </Box>
                                    }
                                    sx={getProfileMobileTabStyles()}
                                />
                            )
                        })}
                    </Tabs>
                </Box>

                <Outlet />
            </Box>
        </Box>
    )
}

export default ProfileLayout
